import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterForm from "./FilterForm";
import { useOrgan } from "../hooks/useOrgan";
import { organizationPrimaryColors } from "../layouts/PermanentSidebarMUI";

/**
 *
 * @param {Object} props
 * @param {Array} props.autoCompleteFields
 * @param {Function} props.onSubmit
 * @param {Function} props.onClear
 * @param {boolean} [props.defaultOpen]
 * @returns
 */
const FilterCollapse = ({
  autoCompleteFields,
  onSubmit,
  onClear,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  return (
    <div style={{ marginBottom: 16 }}>
      <Button
        variant="contained"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls="filter-collapse"
        sx={{
          backgroundColor: primaryColor,
          color: "white",
          textTransform: "capitalize",
          fontWeight: "bold",
          fontSize: "1rem",
        }}
        startIcon={<FilterListIcon />}>
        {open ? "Ocultar filtros" : "Mostrar filtros"}
      </Button>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <div id="filter-collapse" style={{ marginTop: 16 }}>
          <FilterForm
            autoCompleteFields={autoCompleteFields}
            onSubmit={onSubmit}
            onClear={onClear}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default FilterCollapse;
